import { IconButton, Stack, Typography } from '@mui/material';

import ChevronLeftIcon from 'modules/common/components/Icons/ChevronLeftIcon';
import ChevronRightIcon from 'modules/common/components/Icons/ChevronRightIcon';

interface PanelNavProps {
    currentPanelIdx: number;
    totalPanels: number;
    canPrev: boolean;
    canNext: boolean;
    scrollToPanel: (idx: number) => void;
}

/**
 * Desktop-only chevron group with a panel indicator (e.g. "1/3"). Hidden on touch devices
 * via `@media (hover: hover)` and on the storybook MobileFrame via `data-mobile-hidden`.
 */
export default function PanelNav({
    currentPanelIdx,
    totalPanels,
    canPrev,
    canNext,
    scrollToPanel,
}: Readonly<PanelNavProps>) {
    return (
        <Stack
            data-mobile-hidden
            direction="row"
            alignItems="center"
            spacing={1}
            sx={{
                display: 'none',
                '@media (hover: hover)': { display: 'flex' },
            }}>
            <Typography variant="body1">
                {currentPanelIdx + 1}/{totalPanels}
            </Typography>
            <IconButton
                size="small"
                disabled={!canPrev}
                onClick={() => scrollToPanel(currentPanelIdx - 1)}
                aria-label="Previous page">
                <ChevronLeftIcon fontSize="small" />
            </IconButton>
            <IconButton
                size="small"
                disabled={!canNext}
                onClick={() => scrollToPanel(currentPanelIdx + 1)}
                aria-label="Next page">
                <ChevronRightIcon fontSize="small" />
            </IconButton>
        </Stack>
    );
}
